import React from 'react';

const Tablet: React.FC<React.SVGProps<SVGSVGElement>> = ({ ...props }) => {
  return (
    <svg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="64" height="64" rx="4" fill="#E8FEF3" />
      <path
        d="M50.0481 22.5652L48.2763 27.966L47.9137 29.0697L47.7196 29.6582L40.9027 50.4185C40.2569 52.3873 38.1352 53.4592 36.1661 52.8104L21.7211 48.068C19.752 47.4223 18.68 45.3039 19.3289 43.3351L28.4744 15.4882C29.1201 13.5194 31.2387 12.4475 33.2078 13.0932L40.7659 15.5741L47.6528 17.8356C49.6251 18.4781 50.6939 20.5996 50.0481 22.5652Z"
        fill="#1D232A"
      />
      <path
        d="M50.0483 22.5659L48.2765 27.9666L41.4913 20.7878L38.5361 17.6581C38.9369 17.4259 39.7767 16.6116 40.766 15.5747L47.653 17.8362C49.6252 18.4787 50.694 20.6002 50.0483 22.5659Z"
        fill="#42EC9A"
      />
      <path
        d="M47.9139 29.0667L47.7199 29.6551C45.7604 27.6036 43.804 25.5552 41.8445 23.5037C41.7427 23.3955 41.7968 23.1983 41.9018 23.1188C42.0322 23.0266 42.1849 23.0679 42.2867 23.1761C42.9356 23.8599 43.5909 24.5406 44.2398 25.2244C45.4677 26.5031 46.6892 27.7849 47.9139 29.0667Z"
        fill="#42EC9A"
      />
      <path
        d="M31.6556 51.3254L17.0356 46.5258C15.0665 45.8801 13.9945 43.7586 14.6434 41.7929L23.7889 13.9461C24.4346 11.9772 26.5564 10.9053 28.5223 11.5542L43.1423 16.3538C45.1113 16.9995 46.1833 19.121 45.5344 21.0867L36.3889 48.9336C35.7432 50.8992 33.6246 51.9711 31.6556 51.3254Z"
        fill="#00A868"
      />
      <path
        d="M42.5641 21.7748L25.7813 16.2642L17.632 41.0776L34.4149 46.5882L42.5641 21.7748Z"
        fill="#42EC9A"
      />
      <path
        d="M18.2652 40.7575L26.1024 16.8942L27.3556 17.3057L19.5183 41.169L18.2652 40.7575Z"
        fill="#FCFCFC"
        stroke="#FCFCFC"
      />
      <path
        d="M35.018 17.2158C35.4501 17.2158 35.8005 16.8655 35.8005 16.4333C35.8005 16.0012 35.4501 15.6509 35.018 15.6509C34.5858 15.6509 34.2354 16.0012 34.2354 16.4333C34.2354 16.8655 34.5858 17.2158 35.018 17.2158Z"
        fill="#1D232A"
      />
      <path
        d="M29.4928 35.0751C29.4482 35.2119 29.5309 35.355 29.6677 35.39C31.764 35.918 33.9367 34.7316 34.6047 32.6451C35.2727 30.5585 34.1912 28.332 32.1776 27.5464C32.044 27.4955 31.8976 27.5655 31.8531 27.7023L31.3823 29.1749C31.3378 29.3117 31.4078 29.458 31.5382 29.5184C32.4734 29.9478 32.9601 31.0165 32.6388 32.0216C32.3175 33.0267 31.2996 33.612 30.288 33.4211C30.1481 33.3957 30.0081 33.472 29.9636 33.6088L29.4928 35.0751Z"
        fill="#1D232A"
      />
      <path
        d="M29.2412 28.8405C29.1744 28.7133 29.0217 28.6656 28.8945 28.7292L26.9795 29.8361C26.8713 29.8965 26.7823 29.9983 26.7441 30.1255C26.7027 30.2528 26.7155 30.3864 26.7695 30.5009L27.6857 32.5142C27.7525 32.6415 27.9052 32.6892 28.0324 32.6256C28.096 32.5938 28.1406 32.5365 28.1596 32.4729L29.2603 29.0346C29.2762 28.9741 29.273 28.9042 29.2412 28.8405Z"
        fill="#1D232A"
      />
    </svg>
  );
};

export default Tablet;
